<template>
  <div class="wrapper">
    <dean-dialog
            class="logout-dialog"
            title="Uitloggen"
            :icon="lockIcon"
            :small="true"
    >
      <slot><!--Slot for load overlay-->

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <span class="dean-dialog-logo" slot="dean-dialog-logo">
        <dean-icon class="deanone-logo" :glyph="headerLogo"></dean-icon>
      </span>
      <p> Weet u zeker dat u wilt uitloggen? </p>
      <span slot="dean-dialog-button-group">
        <dean-button :dialog-button="true" @click.native="close()">Sluiten</dean-button>
        <dean-button primary="true" :dialog-button="true" @setLoad="true"
                     @click.native="logoutClick">Uitloggen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<script lang="ts">
  // VUE
  import {
    Vue,
    Component,
    Prop,
    Watch,
  } from 'vue-property-decorator';
  import { deanDialogBus } from '@/main';
  import axios from 'axios';
  import { logoutFromKeycloak } from '@/services/keycloak';

  import {
    deanInputField,
    deanButton,
    deanHeader,
    lockIcon,
    goCompleetLogo,
    deanIcon,
  } from '@deanone/dean-components';

  import alertNotification from '@/components/deanComponents/deanNotification.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanDialog from '@/components/deanComponents/deanDialog.vue';

  @Component({
    components: {
      DeanNotification,
      deanInputField,
      deanButton,
      deanDialog,
      deanHeader,
      deanIcon,
      alertNotification,
    },
  })

  /**
   * Class for logout.
   *
   * @class      Logout (name)
   */
  export default class Logout extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: string,
    };
    public lockIcon: object = lockIcon;
    public data: object = {
      username: null,
      password: null,
    };

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    get headerLogo() {
      return this.$store.getters.getTheme.data.headerLogo;
    }

    /**
     * Process logout form
     */
    public logoutClick() {
      const keycloakEnabled = process.env.VUE_APP_KEYCLOAK_ENABLED === 'true';
      this.$store.dispatch('setLoadOverlay', true);
      const loginUrl = `${window.location.origin}${this.$router.resolve({ name: 'auth.login', query: { loggedOut: '1' } }).href}`;

      if (keycloakEnabled) {
        // Keycloak owns the session in this case (backend auth.logout is a no-op
        // that just says "Use Keycloak to logout."), so go straight to Keycloak's
        // own end_session endpoint instead of calling our backend first.
        // Local tokens/auth state are intentionally NOT cleared here — that only
        // happens in the logout callback route, which Keycloak only redirects to
        // after the user explicitly confirms the logout. This way, if the user
        // cancels on Keycloak's confirmation screen, the WS Portal session stays intact.
        const logoutCallbackUrl = `${window.location.origin}${this.$router.resolve({ name: 'auth.logoutCallback' }).href}`;
        deanDialogBus.$emit('close');
        this.$store.dispatch('setLoadOverlay', false);
        logoutFromKeycloak(logoutCallbackUrl);
        return;
      }

      axios.post('/-/trade/api/auth.logout',).then(
        (response) => {
          deanDialogBus.$emit('close');
          this.$store.dispatch('setLoadOverlay', false);
          this.$store.commit('SET_IS_AUTHENTICATED', false);
          localStorage.layouts = JSON.stringify([]);
          window.location.href = loginUrl;
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }
  }
</script>

<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .logout-dialog {
  }

  .logout-dialog .dean-dialog-logo {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin-bottom: 15px;
  }

  .deanone-logo {
    grid-column: 2 / span 4;
  }
</style>
